<template>
  <div class="connect-video-modal-backdrop">
    <div class="connect-video-modal">
      <div class="modal-content">
        <div class="modal-content-title">
          Welcome to your Weavr game room!
        </div>
        <div class="modal-content-item">
          Your video and audio will be streamed to other players.
        </div>
        <div class="modal-content-item">
          Click the button below to request the necessary permissions from your browser.
        </div>
        <div class="modal-content-item" :style="{ fontSize: '0.8em' }">
          (If this message persists, check your browser's camera permission settings.)
        </div>
      </div>
      <SpinnerButton
        class="modal-button"
        @click="emitClick"
      >
        Enable video and audio
      </SpinnerButton>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import SpinnerButton from '@/components/utilComponents/SpinnerButton.vue';

export default Vue.extend({
  name: 'EnableVideoModal',
  components: {
    SpinnerButton
  },
  props: {
  },
  data: () => ({
    isAddingToPromptPack: false,
    selectedPromptPack: {}
  }),
  computed: {
    auth0UserId: function () {
      return this.$auth.user.sub.replace(/\|/g, '_');
    },
    idToken: function () {
      return this.$auth.idToken;
    }
  },
  methods: {
    emitClick() {
      this.$emit('click');
    }
  },
})
</script>

<style scoped lang="scss">
.connect-video-modal-backdrop {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: $smoke-gray;
  z-index: 500;
}

.connect-video-modal {
  position: absolute;
  display: flex;
  flex-direction: column;
  text-align: center;
  top: 30%;
  left: 30%;
  right: 30%;
  color: $natural-white;
  background-color: $brand-teal;
  border-radius: 0.4em;
  box-shadow: 0 6px 8px -4px $smoke-gray;
}

.modal-content {
  flex: 1;
  padding: 0.2em 1.2em;
  margin: 1em auto;
  font-size: 1.1em;
}

.modal-content-title {
  font-size: 1.4em;
  padding: 0.3em;
}

.modal-content-item {
  padding: 0.3em;
}

.modal-button {
  flex: 0;
  color: $smoke-gray;
  width: max-content;
  padding: 1em 1.6em;
  margin: 1em auto;
  background-color: $brand-gold;
  cursor: pointer;
  border-radius: 0.4em;
  &:hover {
    background-color: $light-gold;
  }
}
</style>